var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E1490F5F-E685-4FF3-B533-DF9834F597BE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "questionnaire--Contact-information-eror",
    transform: "translate(-1143.000000, -381.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Obligation",
    transform: "translate(1144.000000, 382.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cart;-action;-shop;-store;-buy;-check"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,25.5 C6.5,26.6666667 7.66128109,25.9932713 7.66128109,25.9932713 L25.8018707,8.06108109 C26.5104875,7.36060491 26.5104875,6.22583331 25.8018707,5.52535713 C25.0932539,4.82488096 23.9452945,4.82488096 23.2366778,5.52535713 L5.5,23 C4.83333333,23.8888889 4.83333333,24.7222222 5.5,25.5 Z",
    id: "Path",
    fill: "#617984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4188369,-0.5 C24.1191871,-0.5 31.1966147,6.57742763 31.1966147,15.2777778 C31.1966147,23.9781279 24.1191871,31.0555556 15.4188369,31.0555556 C6.71848679,31.0555556 -0.358940833,23.9781279 -0.358940833,15.2777778 C-0.358940833,6.57742753 6.71848661,-0.5 15.4188369,-0.5 Z",
    id: "Shape",
    stroke: "#617984",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.920a78cf165aac25804ba34886564c09.svg";
export { ForwardRef as ReactComponent };